<wlx-tabs>
  <wlx-tab [title]="'benefits.benefit-mgt.advanced-search.membership-label' | translate | titlecase">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-3">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.membership-level-label' | translate | titlecase }}
          </label>
          <select [(ngModel)]="searchParams.MemebrshipLevelId" class="form-control">
            <option [value]="0">{{ 'common.select' | translate | titlecase }}</option>
            <option [value]="membershipLevel.MembershipLevelId" *ngFor="let membershipLevel of membershipLevels">
              {{ membershipLevel.Name }}
            </option>
          </select>
        </div>
        <div class="col-sm-3">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.profile-status-label' | translate | titlecase }}
          </label>
          <select [(ngModel)]="searchParams.ProfileStatus" class="form-control">
            <option [value]="0">{{ 'common.select' | translate | titlecase }}</option>
            <option [value]="memberType.MemberType" *ngFor="let memberType of memberTypes">{{ memberType.MemberType }}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-6">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.benefit-available-label' | translate | titlecase }}
          </label>
          <select [(ngModel)]="searchParams.BenefitTypeId" class="form-control">
            <option [value]="0">--{{ 'common.select' | translate | titlecase }}--</option>
            <option [value]="memberType.Id" *ngFor="let memberType of benefitTypes">{{ memberType.Name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-6">
          <label
            ><input type="checkbox" [(ngModel)]="searchParams.ActiveOnly" />
            {{ 'benefits.benefit-mgt.advanced-search.active-only-label' | translate | titlecase }}</label
          >
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-6">
          <label
            ><input type="checkbox" [(ngModel)]="searchParams.MembersEligibleForRenwal" />
            {{ 'benefits.benefit-mgt.advanced-search.members-eligible-for-renewal-label' | translate | titlecase }}</label
          >
        </div>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'benefits.benefit-mgt.advanced-search.billing-label' | translate | titlecase">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-3">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.billing-anchor-month-label' | translate | titlecase }}
          </label>
          <select [(ngModel)]="searchParams.BillingAnchorMonth" class="form-control">
            <option [value]="0">{{ 'common.select' | translate | titlecase }}</option>
            <option [value]="i" *ngFor="let month of months; let i = &quot;index+1&quot;">{{ month }}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.billing-revenue-item-label' | translate | titlecase }}
          </label>
          <wl-revenue-item-selector
            [noneValueDisplay]="'common.select' | translate | titlecase"
            [(ngModel)]="searchParams.BillingRevenueItemNum"
          ></wl-revenue-item-selector>
        </div>
      </div>
      <div class="form-group">
        <div class="col-xs-6">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.dues-amount-label' | translate | titlecase }}
          </label>
          <ul class="list-inline form-inline wl-dues-amount-between">
            <li>
              {{ 'common.between' | translate | titlecase }}
            </li>
            <li>
              <div class="input-group">
                <div class="input-group-addon">$</div>
                <input type="number" [(ngModel)]="searchParams.DuesAmountMin" class="form-control" />
              </div>
            </li>
            <li>
              {{ 'common.and' | translate | titlecase }}
            </li>
            <li>
              <div class="input-group">
                <div class="input-group-addon">$</div>
                <input type="number" [(ngModel)]="searchParams.DuesAmountMax" class="form-control" />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-3">
          <label>
            {{ 'benefits.benefit-mgt.advanced-search.unpaid-dues-invoice-due-after-label' | translate | titlecase }}
          </label>
          <wl-date-selector [(ngModel)]="searchParams.UnpaidDuesAfter"></wl-date-selector>
        </div>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'benefits.benefit-mgt.advanced-search.affiliation-codes-label' | translate | titlecase">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12 col-md-8">
          <wl-affcode-selector #affCodeSelector [(ngModel)]="searchParams.AffCodes" ngModelChange="resetAffCodes()"></wl-affcode-selector>
        </div>
      </div>
    </div>
  </wlx-tab>
</wlx-tabs>
<div>
  <label>
    <input type="checkbox" [(ngModel)]="searchParams.MemberProfilesOnly" />
    {{ 'benefits.benefit-mgt.advanced-search.member-profiles-only-label' | translate | titlecase }}
  </label>
</div>
<div>
  <label>
    <input type="checkbox" [(ngModel)]="searchParams.IncludePrimaryRelationships" />
    {{ 'benefits.benefit-mgt.advanced-search.include-primary-relationships-label' | translate }}
  </label>
</div>
